var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"user-link avatar-hover-container no-outline",attrs:{"to":_vm.userProfileLink(_vm.userId)},nativeOn:{"click":function($event){$event.stopPropagation();}}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }